import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import { BetSlipStatusAbrv } from "@utils";

export default function BetItemPayment() {
	const { t } = useTranslation("mybets");
	const bet = useContext(MyBetsBetContext);

	if (
		bet.betStatus?.abrv == BetSlipStatusAbrv.WON &&
		(bet.betSlipStatus.abrv == BetSlipStatusAbrv.PAID_OUT ||
			bet.betSlipStatus.abrv == BetSlipStatusAbrv.CASHOUT)
	) {
		return (
			<>
				<div className="bet--mini__col__title">
					{t<string>("ITEM.INFO_PAYOUT_LABEL")}:
				</div>
				<div className="bet--mini__col__title--bold">
					{bet.displayPayout}
				</div>
			</>
		);
	}

	return (
		<>
			<div className="bet--mini__col__title">
				{t<string>("ITEM.INFO_MAX_GAIN_LABEL")}:
			</div>
			<div className="bet--mini__col__title--bold">
				{bet.displayMaxGain}
			</div>
		</>
	);
}
